import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';

export const paymentTermsHeaders: Record<string, EnhancedTableHeader> = {
  BusinessPartnerPolicy_PolicyNumber: {
    name: 'reference',
    title: 'Reference',
    type: EnhancedTableHeaderType.Text,
  },
  PayableBill_NetPremium: {
    name: 'netPremium',
    title: 'Net Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PayableBill_GrossPremium: {
    name: 'grossPremium',
    title: 'Gross Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PayableBill_TotalPremium: {
    name: 'totalPremium',
    title: 'Total Premium',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  BusinessPartnerPolicy_TotalAmountReceived: {
    name: 'amountReceived',
    title: 'Amount Received',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PayableBill_TotalCommission: {
    name: 'commission',
    title: 'Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PayableBill_TaxOnCommission: {
    name: 'taxOnCommission',
    title: 'Tax on Commission',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  PayableBill_AmountPaid: {
    name: 'amountPaid',
    title: 'Amount Paid',
    type: EnhancedTableHeaderType.RoundedCurrency,
  },
  totalBalance: {
    name: 'totalBalance',
    title: 'Total Balance',
    type: EnhancedTableHeaderType.RoundedCurrency,
    disableSort: true,
  },
};
